import React from "react";
import "../pages/boards/boardPills.css";

/** Square pulsing dots — canonical live-activity marker (boards, chat, inbox). */
export default function LiveDots({ className = "" }) {
  return (
    <span className={["board-live-dots", className].filter(Boolean).join(" ")}>
      <span className="board-live-dots__dot" />
      <span className="board-live-dots__dot" />
      <span className="board-live-dots__dot" />
    </span>
  );
}
